import { render, staticRenderFns } from "./SneakerLegacy.vue?vue&type=template&id=5d670023&"
import script from "./SneakerLegacy.vue?vue&type=script&lang=js&"
export * from "./SneakerLegacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports